import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-delete-big-icon',
  templateUrl: 'delete-big-icon.component.html'
})
export class DeleteBigIconComponent {
  constructor() {}
}
